<template>
  <g
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.5"
    color="currentColor"
    clip-path="url(#a)"
  >
    <path
      d="M8.5 9.58h7M4.74 17.089c.19 2.391 2.084 4.422 4.525 4.723.898.11 1.81.188 2.735.188.925 0 1.837-.078 2.735-.188 2.44-.301 4.334-2.332 4.524-4.723.132-1.657.241-3.357.241-5.089 0-1.732-.11-3.432-.24-5.089-.19-2.391-2.084-4.422-4.525-4.723A22.47 22.47 0 0 0 12 2c-.925 0-1.837.078-2.735.188-2.44.3-4.335 2.332-4.524 4.723C4.609 8.568 4.5 10.268 4.5 12c0 1.732.109 3.432.24 5.089Z"
    />
    <path
      d="M10.36 11.496c-1.02-.982-1.92-1.58-1.857-2.035-.003-.383.596-.742 1.856-1.964m3.282.008c1.02.982 1.92 1.58 1.855 2.036.003.383-.595.742-1.855 1.963"
    />
  </g>
  <defs>
    <clipPath id="a"><path fill="#fff" d="M0 0h24v24H0z" /></clipPath>
  </defs>
</template>
